import React from 'react'
import Modal from 'react-modal'
import PropTypes from 'prop-types'

const ConfirmationModal = ({ isOpen, onConfirm, toggleModal }) => {
  return (
    <Modal
      className="modal"
      isOpen={isOpen}
      onRequestClose={toggleModal}
      overlayClassName="overlay -higher-layer"
    >
      <div className="modal__copy">Do you want to continue?</div>
      <div className="modal__actions">
        <button className="btn -outline -sm" onClick={onConfirm} type="button">
          OK
        </button>
        <button className="btn -sm -primary" onClick={toggleModal} type="button">
          Cancel
        </button>
      </div>
    </Modal>
  )
}

ConfirmationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  toggleModal: PropTypes.func.isRequired,
}

export default ConfirmationModal
